<script setup lang="ts">
  import { useEventListener } from '@vueuse/core'
  import { ref } from 'vue'
  import { useSearchGlobalStore } from '@/stores/search-global'

  const emit = defineEmits<{
    (e: 'openSearch'): void,
  }>()

  const searchGlobal = useSearchGlobalStore()

  const refInput = ref<HTMLInputElement | null>(null)

  const openSearch = () => {
    emit('openSearch')
  }
  useEventListener(refInput, 'click', openSearch)
</script>

<template>
  <app-search
    ref="refInput"
    v-model="searchGlobal.search" />
</template>
